import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import conciergeApiClient from 'Services/Apis/Concierge/conciergeApiClient';

export const approveQuotationThunk = createAsyncThunk(
    `ApproveQuotationSlicer/approveQuotationThunk`,
    async (solicitation, { getState, rejectWithValue }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
        };

        const body = {
            note: solicitation.note,
        };

        const reqUrl = `Redemption/${solicitation.solicitationId}/approve`;

        try {
            const { data } = await conciergeApiClient.post(reqUrl, body, { headers });
            return data;
        }
        catch (error) {
            const payload = {
                responseData: error.response?.data,
                requestData: {
                    url: reqUrl,
                    headers,
                    body,
                }
            }

            return rejectWithValue(payload);
        }
    }
);

const initialState = {
    dataApproveSolicitation: false,
    loadingApproveSolicitation: false,
    approveSolicitationHasError: false,
    errorsApproveSolicitation: null
};

const ApproveQuotationSlicer = createSlice({
    name: 'ApproveQuotation',
    initialState,
    reducers: {
        resetDataApproveSolicitation: (state) => {
            state.dataApproveSolicitation = false;
            state.loadingApproveSolicitation = false;
            state.approveSolicitationHasError = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(approveQuotationThunk.pending, (state) => {
            state.dataApproveSolicitation = false;
            state.loadingApproveSolicitation = true;
            state.approveSolicitationHasError = false;
        });
        builder.addCase(approveQuotationThunk.fulfilled, (state, action) => {
            state.dataApproveSolicitation = action.payload;
            state.loadingApproveSolicitation = false;
            state.approveSolicitationHasError = false;
        });
        builder.addCase(approveQuotationThunk.rejected, (state, action) => {
            state.dataApproveSolicitation = false;
            state.loadingApproveSolicitation = false;
            state.approveSolicitationHasError = true;
            state.errorsApproveSolicitation = action.payload;
        });
    },
});

export const { resetDataApproveSolicitation } = ApproveQuotationSlicer.actions;
export default ApproveQuotationSlicer.reducer;